"use client";

import {
  getProductTileContainer,
  getProductTileClickImpressionContainerName,
  getContextToken,
  getProductTileImpressionContext,
  getProductTileScreenContainerContext,
  getProductTileScreenContext,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { ISDUIProductTileVariantRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/types";
import { getBrandAltTag } from "@faire/deprecated-retailer-visitor-shared/features/Marketplace/utils";
import { ProductTile } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/index";
import { ProductTileType } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import { generateProductUrlForBrandPage } from "@faire/deprecated-retailer-visitor-shared/views/brand/utils/generateProductUrlForBrandPage";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React from "react";

export const SDUIProductTileDiscoveryRenderer = ({
  product,
  brand,
  loggingData,
}: ISDUIProductTileVariantRendererProps) => {
  useTraceComponentRender("ProductTileItem");
  const isLoggedInOrBrandPreview = useIsLoggedInRetailer();
  const { strictLocalize } = useStrictLocalization();
  const productTileContainer = getProductTileContainer(loggingData);
  const context = getProductTileImpressionContext(
    productTileContainer,
    loggingData
  );
  const containerName = getProductTileClickImpressionContainerName(loggingData);
  const requestId = loggingData.request_id;

  const screenContext = getProductTileScreenContext(loggingData);
  const containerContext = getProductTileScreenContainerContext(loggingData);
  const contextToken = getContextToken(loggingData);

  const productLinkPropsBrand = {
    productUrl: generateProductUrlForBrandPage(
      product.product?.token ?? "",
      product.selected_product_option_token,
      undefined
    ),
  };

  const altTag = getBrandAltTag(
    product.product?.name,
    brand?.name,
    strictLocalize
  );
  const productLinkProps = productLinkPropsBrand;

  const productTileBrand = ILeanProductTile.IBrand.build({
    token: brand?.token,
    name: brand?.name,
    profile_image: brand?.profile_image,
    insider_benefits: brand?.insider_benefits,
    insider_label: brand?.insider_label,
    minimum_order_amount: brand?.minimum_order_amount,
  });

  return (
    <ProductTile
      product={product}
      brand={productTileBrand}
      loggingContext={{
        impressionProviderProps: {
          context,
          requestId,
          screenContext,
          containerContext,
          contextToken,
          trackedLinkContainerName: containerName,
        },
      }}
      tileInteractions={{
        props: {
          productLinkProps,
        },
      }}
      isLoggedIn={isLoggedInOrBrandPreview}
      type={ProductTileType.TILE_WITH_BRAND}
      imageConfigProps={{
        altTag,
      }}
    />
  );
};
